import { render } from "./AllTestItems.vue?vue&type=template&id=60b544fd"
import script from "./AllTestItems.vue?vue&type=script&lang=js"
export * from "./AllTestItems.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__